// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2qDoq","location":"Header_location__2mkJT"};